import { HTMLAttributes, ReactElement, useId } from 'react';
import classes from './TextField.module.css';
import { Label } from '../Label/Label';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import cn from 'classnames';
import { Description } from '../Description/Description';

type TextFieldProps = {
  label: string;
  description?: string;
  type: 'text' | 'email' | 'password' | 'number';
  name: string;
  value?: string | number;
  required?: boolean;
  errorMessage?: string;
  w100?: boolean;
  spacing?: boolean;
  onChange?: (value: any) => void;
  placeholder?: string;
} & HTMLAttributes<HTMLInputElement>;

export const TextField = ({
  label,
  description,
  errorMessage,
  required,
  className: givenClassName,
  onChange,
  w100 = false,
  spacing = true,
  ...rest
}: TextFieldProps): ReactElement => {
  const id = rest.name || useId();
  const descriptionId = `${id}-description`;

  const combinedClassName = cn(classes.input, givenClassName, {
    [classes.inputError]: errorMessage,
    [classes.spacing]: spacing && !errorMessage,
  });

  return (
    <div style={w100 ? { width: '100%' } : {}}>
      <Label
        label={label}
        htmlFor={id}
        size={'ml'}
        required={required}
        spacing={spacing}
      />
      {description && (
        <Description description={description} id={descriptionId} size={'ml'} />
      )}
      <input
        {...rest}
        className={combinedClassName}
        id={id}
        aria-describedby={description ? descriptionId : undefined}
        onChange={onChange}
      />
      {errorMessage && (
        <div className={classes.errorWrapper}>
          <ErrorMessage error={errorMessage} size={'ml'} />
        </div>
      )}
    </div>
  );
};
